require('./multiStepSelectorWidget.js.i18n.json');
require('./multiStepSelectorWidget.tpl.html');
require('./multiStepSelectorWidgetController.js');

const MultiStepSelectorWidgetComponent = {
    templateUrl: '/configuration/multiStepSelectorWidget/multiStepSelectorWidget.tpl.html',
    controller: 'multiStepSelectorWidgetController',
    bindings: {
        mode: '<',
        step1ItemName: '<',
        step2ItemName: '<',
        step2MultiSelect: '<',
        isDisabled: '<',
        name:'<'
    }
};

angular.module('ums.configuration')
    .component('uiMultiStepSelectorWidget', MultiStepSelectorWidgetComponent);
